import { BaseComponent } from '../../base-component';

export class SustainabilityShortInfoComponent extends BaseComponent {
    public rootSelector = '.js_pdp_sustainability-short-info__root';

    public async onHtmlLoaded(): Promise<void> {
        if (!this.isPresent()) {
            return;
        }

        this.getChildElements('.js_pdp_sustainability-short-info__category-icon').forEach(el =>
            el.addEventListener('click', (event: Event) => {
                const categoryName = (event.currentTarget as HTMLElement).dataset['categoryName'];
                o_global.eventQBus.emit('ft5.pdp-sustainability-short-info-sheet.open', {
                    name: categoryName,
                });
                this.trackEvent({
                    product_SustainabilityTags: categoryName,
                    product_SustainabilityActivity: 'click',
                });
            })
        );
    }
}
